<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import Vue from 'vue';
	import AppConfig from '@/config';

	
	export default {
		name: 'app',
		watch: {
			// Refresh the token when users navigate between pages.
			$route() {
				Vue.$auth.updateToken(AppConfig.auth.refreshThreshold);
			}
		}
	};
</script>